module.exports = __webpack_public_path__ + "img/uil_redo.e1675ab2.svg";